import { render, staticRenderFns } from "./StartupApresentacao.vue?vue&type=template&id=152b414d&scoped=true"
import script from "./StartupApresentacao.vue?vue&type=script&lang=js"
export * from "./StartupApresentacao.vue?vue&type=script&lang=js"
import style0 from "./StartupApresentacao.vue?vue&type=style&index=0&id=152b414d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152b414d",
  null
  
)

export default component.exports